/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LabelPresetOut,
  LabelsIn,
  ProblemDetail
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Этикетки палетов партии (PDF); формат запоминается
 */
export const labelsPrintLabels = (
    batchId: number,
    labelsIn: BodyType<LabelsIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<unknown>(
      {url: `/api/v1/batches/${batchId}/labels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: labelsIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getLabelsPrintLabelsMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof labelsPrintLabels>>, TError,{batchId: number;data: BodyType<LabelsIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof labelsPrintLabels>>, TError,{batchId: number;data: BodyType<LabelsIn>}, TContext> => {

const mutationKey = ['labelsPrintLabels'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof labelsPrintLabels>>, {batchId: number;data: BodyType<LabelsIn>}> = (props) => {
          const {batchId,data} = props ?? {};

          return  labelsPrintLabels(batchId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LabelsPrintLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof labelsPrintLabels>>>
    export type LabelsPrintLabelsMutationBody = BodyType<LabelsIn>
    export type LabelsPrintLabelsMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Этикетки палетов партии (PDF); формат запоминается
 */
export const useLabelsPrintLabels = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof labelsPrintLabels>>, TError,{batchId: number;data: BodyType<LabelsIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof labelsPrintLabels>>,
        TError,
        {batchId: number;data: BodyType<LabelsIn>},
        TContext
      > => {

      const mutationOptions = getLabelsPrintLabelsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Форматы печати: последний — первым
 */
export const labelsListPresets = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<LabelPresetOut[]>(
      {url: `/api/v1/labels/presets`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getLabelsListPresetsQueryKey = () => {
    return [
    `/api/v1/labels/presets`
    ] as const;
    }

    
export const getLabelsListPresetsQueryOptions = <TData = Awaited<ReturnType<typeof labelsListPresets>>, TError = ErrorType<ProblemDetail>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof labelsListPresets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLabelsListPresetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof labelsListPresets>>> = ({ signal }) => labelsListPresets(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof labelsListPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LabelsListPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof labelsListPresets>>>
export type LabelsListPresetsQueryError = ErrorType<ProblemDetail>


export function useLabelsListPresets<TData = Awaited<ReturnType<typeof labelsListPresets>>, TError = ErrorType<ProblemDetail>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof labelsListPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof labelsListPresets>>,
          TError,
          Awaited<ReturnType<typeof labelsListPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLabelsListPresets<TData = Awaited<ReturnType<typeof labelsListPresets>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof labelsListPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof labelsListPresets>>,
          TError,
          Awaited<ReturnType<typeof labelsListPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLabelsListPresets<TData = Awaited<ReturnType<typeof labelsListPresets>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof labelsListPresets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Форматы печати: последний — первым
 */

export function useLabelsListPresets<TData = Awaited<ReturnType<typeof labelsListPresets>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof labelsListPresets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLabelsListPresetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




